import { router } from '../';

export const mainRoute = async () => {
  router.navigate('/start');
};
